import * as CubeTree from '../../../cubeTree/index';
import FrontCubeData from '../../../frontCubeData/index';

export function cabinetPosition(cube: CubeNode): void {
    let backgroundColor: string = FrontCubeData.getValue(cube.id, 'moduleColor') || '';
    let layerWidth: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'moduleWidth');
    let layerHeight: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'moduleDepth');
    let left: LogicsicsMeasurement = 0;
    let bottom: LogicsicsMeasurement = 0;

    cube.jView.css({
        top: '',
        bottom: bottom,
        left: left,
        position: 'absolute',
        height: layerHeight,
        width: layerWidth,
        backgroundColor: backgroundColor
    });
}
